export default "__VITE_ASSET__WJG4Ot99__"